import React from 'react'
import { connect } from 'react-redux'
import PageTitle from '../components/page-title'
import * as actions from '../actions/summary'
import SummaryDiamondList from '../components/summary-diamond-list'
import SummaryJewelryList from '../components/summary-jewelry-list'
import OrderSummary from '../components/order-summary'
import HorizontalRule from '../components/horizontal-rule'
import Spacer from '../components/spacer'
import Button from '../components/button'
import SessionModal from '../components/session-modal'
import * as summarySelectors from '../selectors/summary'
import * as cartSelectors from '../selectors/cart'
import * as clientSelectors from '../selectors/client'

const mapStateToProps = (state, ownProps) => {
  return {
    diamondsForCheckout: summarySelectors.getDiamondsForCheckout(state),
    jewelryForCheckout: summarySelectors.getJewelryForCheckout(state),
    diamondPrices: cartSelectors.getDiamondPrices(state),
    jewelryPrices: cartSelectors.getJewelryPrices(state),
    numCheckoutItems: summarySelectors.getNumCheckoutItems(state),
    clientProfileComplete: clientSelectors.getClientProfileComplete(state),
    ...state.summary
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    openSessionModal: () => {
      dispatch(actions.openSessionModal())
    },
    closeSessionModal: () => {
      dispatch(actions.closeSessionModal())
    },
    completeSessionFieldChanged: (field, subfield, value) => {
      dispatch(actions.completeSessionFieldChanged(field, subfield, value.target.value))
    },
    sendEmail: () => {
      dispatch(actions.sendEmail())
    }
  }
}

const renderDiamondJewelrySeparator = (jewelry, diamonds) => (
  Object.keys(jewelry).length > 0 && Object.keys(diamonds).length > 0
)

const Summary = props => (
  <div>
    <SessionModal
      onRequestClose={props.closeSessionModal}
      isOpen={props.modalOpen}
      onFieldChange={props.completeSessionFieldChanged}
      values={props.completeSessionForm}
      onClick={props.sendEmail}
      sendSummaryRequested={props.sendSummaryRequested}
      sendSummarySuccess={props.sendSummarySuccess}
      sendSummaryFail={props.sendSummaryFail}
      clientProfileComplete={props.clientProfileComplete}
    />
    <PageTitle title='Summary'>The final details</PageTitle>
    <SummaryJewelryList jewelry={props.jewelryForCheckout} prices={props.jewelryPrices} />
    {renderDiamondJewelrySeparator(props.jewelryForCheckout, props.diamondsForCheckout) && <HorizontalRule />}
    <Spacer xs />
    <SummaryDiamondList diamonds={props.diamondsForCheckout} prices={props.diamondPrices} />
    <HorizontalRule />
    <Spacer sm />
    <OrderSummary />
    <Spacer sm />
    <HorizontalRule />
    <Spacer sm />
    <Button disabled={props.numCheckoutItems === 0} onClick={props.openSessionModal} center>Complete Session</Button>
    <Spacer xl />
  </div>
)

export default connect(mapStateToProps, mapDispatchToProps)(Summary)



// WEBPACK FOOTER //
// ./src/containers/summary.js